import React, { Component, PropTypes } from 'react';
import { Button, Input } from 'semantic-ui-react';
import SchedulingModal from '../../../pco/cases/organize/SchedulingModal';
import moment from 'moment';
import { DATE_FORMAT } from 'common/components/PreplanificationSelection';

class PreplannificationInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpened: false,
    };
    this._onModalSave = this._onModalSave.bind(this);
    this._onModalClose = this._onModalClose.bind(this);
    this._onClick = this._onClick.bind(this);
    this._cleanValue = this._cleanValue.bind(this);
  }

  _onModalSave(value) {
    this.setState({
      modalOpened: false,
    });
    this.props.onChange(value.date);
  }

  _onModalClose() {
    this.setState({
      modalOpened: false,
    });
  }

  _onClick() {
    this.setState({
      modalOpened: true,
    });
  }

  _formatValue(value) {
    if (value && value.length) {
      const date = moment(value, DATE_FORMAT).weekday(0);
      const week = date.isoWeek();

      const formatted = `Semaine ${week} à partir du ${date.format(
        DATE_FORMAT
      )}`;
      return formatted;
    } else {
      return '';
    }
  }

  _cleanValue() {
    this.props.onChange('');
  }

  render() {
    const { value, placeholder, disabled } = this.props;

    return (
      <div>
        <Input
          onClick={this._onClick}
          value={this._formatValue(value)}
          placeholder={placeholder}
          label={
            <Button
              basic
              icon="close"
              style={{ borderLeft: 'transparent' }}
              onClick={this._cleanValue}
            />
          }
          labelPosition="right"
          autoComplete="off"
          disabled={disabled}
        />
        {this.state.modalOpened && (
          <SchedulingModal
            onSaved={this._onModalSave}
            onClosed={this._onModalClose}
            multiSelection={false}
            value={this.props.value}
          />
        )}
      </div>
    );
  }
}

PreplannificationInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

PreplannificationInput.default = {
  placeholder: '',
};

export default PreplannificationInput;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/components/PreplannificationInput.js